<template>
    <div id="container">
        <div id="placeholder">
            <div id="wrapper" v-if="!this.hasFlashPlayerVersion">
                <div class='flash-plugin-button' @click="getFlashPlayer">
                    <img src="/img/flash_plugin_icon.png"/><br/>
                    <span>{{ $t('kollus_player.notify_message.flash.install_guide') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swfobject from 'swfobject';
import { Base64 } from 'js-base64';
import loadJsCss from 'load-js-css';
import vgControllerLoader from '../vgControllerLoader';

export default {
    name: 'kollus-player-flash',
    props: {
        playerPolicy: {
            type: Object,
            required: true,
        },
        mediaInfo: {
            type: Object,
            required: true,
            default: () => {},
        },
    },
    data() {
        return {
            playerConfig: this.playerPolicy.player_config.flash,
        }
    },
    methods: {
        getFlashPlayer() {
            window.location.href = 'http://get.adobe.com/flashplayer/';
        },
    },
    beforeMount() {
        loadJsCss.list(this.playerConfig.resources);
    },
    mounted() {
        if (this.hasFlashPlayerVersion) {
            swfobject.createSWF({
                data: '/flash/KollusPlayer.swf?_bust=' + this.playerPolicy.bust_version,
                width: '100%',
                height: '100%',
                id: 'kollusplayer',
                name: 'kollusplayer',
            }, {
                bgcolor: '#000000',
                quality: 'high',
                allowScriptAccess: 'always',
                allowFullScreen: 'true',
                allowNetworking: 'all',
                wmode: 'direct',
                flashvars: 'pd=' + this.flashvars + '&flashRoot=/flash/',
            }, 'placeholder');

            vgControllerLoader.load('flash', 'kollusplayer').then((controllee) => {
                try {
                    // postmessage를 통해 전달받은 플레이어 제어 명령 핸들러 등록
                    controllee.init();

                    // flash player 이벤트 핸들러 function 등록
                    Kollus.Utility.merge_object(window, controllee.player_event_listeners());

                    // flasha player 인터페이스 function 등록
                    Kollus.Utility.merge_object(window, {
                        isReady: function() {
                            return true;
                        },
                        playerCallbackIsReady: function() {
                            controllee.register_event_listeners();
                        }
                    });
                } catch(e) {
                    // 발생 가능한 예외
                    // 1. PostMessage 사용 불가
                    console.error(e);
                }
            });
        }
    },
    computed: {
        hasFlashPlayerVersion() {
            return swfobject.hasFlashPlayerVersion('1.0.0');
        },
        flashvars() {
            return encodeURIComponent(Base64.encode(JSON.stringify({
                ...this.mediaInfo,
                plugin: [
                    { src: '/flash/plugins/CaptioningPlugin.' + this.playerConfig.plugin.captioning_version + '.swf', metdata: {} },
                    { src: '/flash/plugins/ProgressPlugin.' + this.playerConfig.plugin.progress_version + '.swf', metdata: {} },
                    { src: '/flash/plugins/PseudoStreamingPlugin.' + this.playerConfig.plugin.pseudo_streaming_version + '.swf', metdata: {} },
                    {
                        src: '/flash/plugins/NScreenPlugin.' + this.playerConfig.plugin.nscreen_version + '.swf',
                        metdata: { nscreenCallInterval: 5 },
                    },
                ],
            })));
        },
    },
}
</script>

<style scoped>
.flash-plugin-button {
    color: #ccc;
    font-size: 13px;
    line-height: 20px;
    cursor: pointer;
}
</style>
